/** Shown where an image slot is empty or fails to load. */
export const PLACEHOLDER_IMAGE = "/_images/pages/placeholder.webp"

const DG_IMAGES_PATH = "/_images/articles/"

/**
 * Resolve the stored `i_image` of an article image to something a browser can load.
 *
 * - empty → "" (callers decide on a placeholder)
 * - `http(s)://…` → used as is (AI articles, and DG images an admin replaced)
 * - DG bare filename → `/_images/articles/<file>` (the file in `public/`), prefixed with `base`
 *   when an absolute URL is needed
 * - anything else (AI) → returned untouched
 */
export function resolveArticleImage(
   src: string | null | undefined,
   value: string | null | undefined,
   base = "",
): string {
   if (!value) return ""
   if (/^https?:\/\//i.test(value)) return value
   return src === "DG" ? `${base}${DG_IMAGES_PATH}${value.replace(/^\/+/, "")}` : value
}

export function getImageAlt(description: unknown, fallback: string): string {
   const text = typeof description === "string" ? description.trim() : ""
   if (!text) return fallback
   if (/^(https?:)?\/\//i.test(text) || /\.(png|jpe?g|webp|gif|svg|avif)(\?.*)?$/i.test(text)) return fallback
   return text
}
